<template>
  <q-item>
    <slot name="avatar" />
    <q-item-section>
      <q-item-label class="row q-col-gutter-sm">
        <q-input
          v-model="item.name"
          label="Titre *"
          :rules="[$validators.required]"
          :readonly="readonly"
          class="col-12 col-md-8"
        />
        <q-input
          v-model="item.price"
          type="number"
          step="0.01"
          label="Tarif unitaire HT"
          :rules="[$validators.required]"
          :readonly="readonly"
          class="col-12 col-md-4"
        >
          <template #append>
            <q-icon name="fa fa-euro-sign" />
          </template>
        </q-input>
        <lwf-editor
          v-model="item.description"
          label="Description *"
          :rules="[$validators.required]"
          :readonly="readonly"
          class="col-12"
        />
        <autocomplete-specialite
          v-model="item.specialties"
          :hide-selected="false"
          :readonly="readonly"
          multiple
          use-chips
          :label="`${_.upperFirst($APP.words.specialty)}(s)`"
          class="col-12"
        />
      </q-item-label>
    </q-item-section>
    <slot name="side" />
  </q-item>
</template>
<script>
import AutocompleteSpecialite from 'components/fields/AutocompleteSpecialite'
import LwfEditor from 'components/core/LwfEditor'
import propsReadonly from '@/mixins/propsReadonly'

export default {
  name: 'ItemAgencyCatalogService',
  components: { AutocompleteSpecialite, LwfEditor },
  mixins: [propsReadonly],
  props: {
    item: {
      type: Object,
      default: undefined
    }
  }
}
</script>
